export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13975.47395fdb.jpg";